export default __webpack_public_path__ + "static/media/icon-artikelzulage-flask.dd7e8936.svg";